export default "__VITE_ASSET__D0ohpjKx__"